<div class="row">
  <div class="col-6 pt-3">
    <button (click)="adicionarCredito()" #btnAdicionarCredito class="btn btn-sm btn-success">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar crédito
    </button>
  </div>
  <div *ngIf="listaItens && listaItens.length > 0" class="col-3 float-right">
    <div class="notice notice-success">
      <strong>Crédito $</strong> <span class="font-weight-bold"> {{totalCredito | number:'1.2-2'}}</span>
    </div>
  </div>
  <div *ngIf="listaItens && listaItens.length > 0" class="col-3 float-right">
    <div class="notice notice-danger">
      <strong>Anulado $</strong> <span class="font-weight-bold"> {{totalAnulado | number:'1.2-2'}}</span>
    </div>
  </div>
</div>
<br />
<table class="table table-eddy" *ngIf="listaItens && listaItens.length > 0">
  <thead>
    <tr>
      <th scope="col">Ficha de despesa orçamentária</th>
      <th scope="col" class="text-right">Valor</th>
      <th scope="col" class="text-right">Dotação</th>
      <th scope="col" class="text-right">Empenhado</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaItens; let idx = index">
      <td *ngIf="!item.editavel" style="width: 55%">
        {{item.ficha.numero}}
        {{item.ficha.funcao.codigo}}.{{item.ficha.subfuncao.codigo}}.{{item.ficha.programa.codigo}}.{{item.ficha.acao.codigo}}.{{item.ficha.despesa.codigo}}
        {{item.ficha.despesa.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 300px" class="text-right">
        {{item.valor_credito | number:'1.2-2'}}
        <span *ngIf="!item.editavel && item.valor_credito > 0" style="border-radius: 50%; height: 10px; width: 10px;"
          class="badge badge-success">&nbsp;</span>
        <span *ngIf="!item.editavel && item.valor_credito < 0" style="border-radius: 50%; height: 10px; width: 10px;"
          class="badge badge-danger">&nbsp;</span>
      </td>

      <td *ngIf="item.editavel" style="width: 50%">
        <p-autoComplete id="fic" [(ngModel)]="entity.ficha" [forceSelection]="true" [autoHighlight]="true"
          [ngModelOptions]="{standalone: true}" [field]="fichaAutoComplete.conversor"
          [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
          (onSelect)="fichaAutoComplete.atualizar(false)" inputStyleClass="form-control form-control-sm" minLength="1"
          [style]="{ width: '100%' }" *ngIf="fichaAutoComplete"
          placeholder="Informe o número da ficha ou descrição da despesa">
          <ng-template let-ficha pTemplate="item">
            {{ficha.numero}} -
            {{ficha.funcao.codigo}}.{{ficha.subfuncao.codigo}}.{{ficha.programa.codigo}}.{{ficha.acao.codigo}}.{{ficha.despesa.codigo}}
            {{ficha.despesa.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td *ngIf="item.editavel" style="width: 300px">
        <input [(ngModel)]="entity.valor_credito" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm text-right" unmask="true" [imask]="imaskConfig" id="valor_credito"
          placeholder="0,00">
      </td>
      <td style="width: 200px" class="text-right">
        <span *ngIf="!item.editavel">{{item.dotacao | number:'1.2-2'}}</span>
        <span *ngIf="item.editavel" class="float-right font-weight-bold">
          {{+dotacao | number:'1.2-2'}}</span>
      </td>
      <td style="width: 200px" class="text-right">
        <span *ngIf="item.id">{{item.empenhado | number:'1.2-2'}}</span>
        <span *ngIf="!item.id" class="float-right font-weight-bold">
          {{+empenhado | number:'1.2-2'}}</span>
      </td>
      <td class="text-right" style="min-width: 150px;">
        <button *ngIf="item.empenhado <= 0 && item.editavel" (click)="salvarCredito(item)"
          class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.empenhado <= 0 && item.editavel" (click)="cancelarCredito(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="item.empenhado <= 0 && !item.editavel" #btnsEditar (click)="editarCredito(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="item.empenhado <= 0 && !item.editavel" (click)="confirmarRemocao(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>